var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHgvIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1936_4451)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.0469 6.4375H12.9172V13.9223H19.6833V10.5534L18.8942 7.82613C18.6564 7.0037 17.9031 6.4375 17.0469 6.4375Z",
    fill: "#FF7058"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.6955 10.5184L17.9923 8.08732C17.871 7.66943 17.4823 7.37695 17.0469 7.37695H13.8572V10.5184H18.6955Z",
    fill: "#84DBFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.6963 10.5164H13.8555V7.375L18.6963 10.5164Z",
    fill: "#CDD6E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.6955 10.5184L17.9923 8.08732C17.871 7.66943 17.4823 7.37695 17.0469 7.37695H13.8572L18.6955 10.5184Z",
    fill: "#F2F2F2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.24989 2.67969H11.6673C12.3573 2.67969 12.9172 3.23921 12.9172 3.92958V13.9217H0V3.92958C0 3.23925 0.559523 2.67969 1.24989 2.67969Z",
    fill: "#F8C460"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.46589 2.68164V5.98425L7.98257 5.50097L7.47598 6.00761L6.96977 5.50097L6.46356 6.00761L5.95649 5.50097L5.44365 6.00761L4.93783 5.50097L4.44873 5.99011V2.68164H8.46589Z",
    fill: "#F2F2F2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20 13.9216V15.334H0.00170898V13.9216H2.08903C2.57649 13.0467 3.51391 12.4551 4.58882 12.4551C5.65955 12.4551 6.59698 13.0467 7.08861 13.9216H13.8047C14.2922 13.0467 15.225 12.4551 16.2999 12.4551C17.3749 12.4551 18.3081 13.0467 18.7997 13.9216H20Z",
    fill: "#334A5E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.296 15.3242C18.296 16.4266 17.4024 17.3203 16.2999 17.3203C15.1975 17.3203 14.3047 16.4266 14.3047 15.3242C14.3047 14.2218 15.1979 13.3281 16.2999 13.3281C17.4028 13.3281 18.296 14.2218 18.296 15.3242Z",
    fill: "#40596B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.1023 15.3251C17.1023 15.7679 16.7432 16.1267 16.3007 16.1267C15.8578 16.1267 15.4983 15.7679 15.4983 15.3251C15.4983 14.8822 15.8574 14.5234 16.3007 14.5234C16.7432 14.523 17.1023 14.8822 17.1023 15.3251Z",
    fill: "#ACB3BA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.58323 15.3242C6.58323 16.4266 5.68912 17.3203 4.58715 17.3203C3.48474 17.3203 2.59106 16.4266 2.59106 15.3242C2.59106 14.2218 3.48474 13.3281 4.58715 13.3281C5.68912 13.3281 6.58323 14.2218 6.58323 15.3242Z",
    fill: "#40596B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.38877 15.3251C5.38877 15.7679 5.03005 16.1267 4.58716 16.1267C4.14427 16.1267 3.78516 15.7679 3.78516 15.3251C3.78516 14.8822 4.14431 14.5234 4.58716 14.5234C5.03001 14.5234 5.38877 14.8822 5.38877 15.3251Z",
    fill: "#ACB3BA"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1936_4451"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHgvIcon);
export default __webpack_public_path__ + "static/media/HgvIcon.c148c60fa40e0659e8dd10bc87707752.svg";
export { ForwardRef as ReactComponent };